const BatteryLow_Icon = ({ className = "" }) => {
  return (
    <svg
      width="16"
      height="16"
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0501 14.8998H2.95011C1.45011 14.8998 0.500105 13.3498 1.20011 11.9998L6.2501 2.1998C7.0001 0.749805 9.0501 0.749805 9.7501 2.1998L14.8501 11.9998C15.5001 13.2998 14.5501 14.8998 13.0501 14.8998Z"
        fill="#FFE600"
      />
      <path
        d="M13.0501 14.8998H2.95011C1.45011 14.8998 0.500105 13.3498 1.20011 11.9998L6.2501 2.1998C7.0001 0.749805 9.0501 0.749805 9.7501 2.1998L14.8501 11.9998C15.5001 13.2998 14.5501 14.8998 13.0501 14.8998Z"
        fill="url(#paint0_linear_462_8822)"
      />
      <path
        d="M7.99995 11.1499C7.79995 11.1499 7.59995 10.9999 7.59995 10.7499C7.59995 9.9999 7.54995 9.3499 7.49995 8.9499C7.44995 8.4499 7.29995 7.8999 7.09995 7.2999C7.04995 7.0999 6.99995 6.9499 6.99995 6.7999C6.99995 6.6499 6.94995 6.4999 6.94995 6.2499C6.94995 5.8499 7.04995 5.5499 7.24995 5.2499C7.49995 4.9999 7.69995 4.8999 7.99995 4.8999C8.29995 4.8999 8.49995 5.0499 8.69995 5.2999C8.89995 5.5499 8.99995 5.8999 8.99995 6.2999C8.99995 6.5499 8.99995 6.6999 8.94995 6.8499C8.94995 6.9999 8.89995 7.1499 8.84995 7.3499C8.64995 7.9499 8.54995 8.4499 8.44995 8.9999C8.39995 9.4499 8.34995 10.0499 8.34995 10.8499C8.39995 10.9499 8.19995 11.1499 7.99995 11.1499ZM7.99995 11.4499C8.24995 11.4499 8.44995 11.5499 8.64995 11.6999C8.79995 11.8499 8.89995 12.0999 8.89995 12.3499C8.89995 12.5999 8.79995 12.7999 8.64995 12.9999C8.49995 13.1499 8.24995 13.2499 7.99995 13.2499C7.74995 13.2499 7.54995 13.1499 7.34995 12.9999C7.19995 12.8499 7.09995 12.5999 7.09995 12.3499C7.09995 12.0999 7.19995 11.8999 7.34995 11.6999C7.54995 11.5499 7.74995 11.4499 7.99995 11.4499Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_462_8822"
          x1="1.13334"
          y1="-0.0366393"
          x2="14.7209"
          y2="0.186561"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE24A" />
          <stop offset="1" stop-color="#EFB274" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BatteryLow_Icon;
